// @core/api/endpoints/tenant/update_tenant_quota.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TenantQuotaResponse,
  UpdateTenantQuotaRequest,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Update tenant quota
 * Modifies the resource quotas for the tenant. This is a platform admin operation typically used for billing plan changes or special allocations.
 */
export async function UpdateTenantQuota(
  tenant_id: string,
  data: UpdateTenantQuotaRequest,
  options?: RequestOptions
): Promise<TenantQuotaResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/quota`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.put<TenantQuotaResponse>(requestPath, data, requestOptions);
}
